import {Component, inject, OnInit, ViewChild} from '@angular/core';
import {MatFormField, MatLabel} from '@angular/material/form-field';
import {MatIcon} from '@angular/material/icon';
import {MatInput} from '@angular/material/input';
import {MatCard, MatCardContent} from '@angular/material/card';
import {MatPaginator} from '@angular/material/paginator';
import { MatSnackBar } from '@angular/material/snack-bar';
import {MatSort, MatSortModule} from '@angular/material/sort';
import {
  MatCell, MatCellDef,
  MatColumnDef,
  MatHeaderCell,
  MatHeaderCellDef,
  MatHeaderRow, MatHeaderRowDef,
  MatRow, MatRowDef,
  MatTable, MatTableDataSource,
} from '@angular/material/table';
import {User} from '../../core/classes/user';
import { SNACKBAR_DURATION } from '../../shared/constants/snackbar.constants';
import {AuthService} from '../../services/auth.service';
import {Router} from '@angular/router';
import {DatePipe} from '@angular/common';
import {MatCheckbox} from '@angular/material/checkbox';
import {FormsModule} from '@angular/forms';
import {FileDownload} from '../../shared/classes/fileDownload';
import {MatButton} from "@angular/material/button";

@Component({
    selector: 'tgrid-user-management',
  imports: [
    MatLabel,
    MatFormField,
    MatIcon,
    MatInput,
    MatCard,
    MatCardContent,
    MatTable,
    MatColumnDef,
    MatHeaderCell,
    MatCell,
    MatPaginator,
    MatHeaderRow,
    MatRow,
    MatHeaderCellDef,
    MatCellDef,
    MatHeaderRowDef,
    MatRowDef,
    MatSortModule,
    DatePipe,
    MatCheckbox,
    FormsModule,
    MatButton,
  ],
    templateUrl: './user-management.component.html',
    styleUrl: './user-management.component.scss',
})
export class UserManagementComponent implements OnInit {
  public authService = inject(AuthService);
  public router = inject(Router);
  private snackBar = inject(MatSnackBar);

  public readonly displayedColumns: string[] = [
    'firstName',
    'lastName',
    'email',
    'username',
    'organization',
    'joinDate',
    'lastLoginDate',
  ];

  public dataSource = new MatTableDataSource<User>();
  public checked: boolean = false;

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  ngOnInit(): void {
    this.authService.getExistingUsers().subscribe({
      next: (res) => {
        this.dataSource.data = res;
        this.dataSource.filterPredicate = this.filterPredicate.bind(this);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
      },
      error: (err) => {
        console.error('Failed to load users:', err);
        this.snackBar.open('Failed to load users. Please try again.', 'Close', {duration: SNACKBAR_DURATION.LONG});
      },
    });
  }

  applyFilter(searchEvent: Event) {
    const searchValue = (searchEvent.target as HTMLInputElement).value.trim().toLowerCase();
    this.dataSource.filter = (searchValue === '') ? ' ' : searchValue;
  }

  navToUser(row: User) {
    this.router.navigateByUrl(`app/profile/${row.id}`);
  }

  filterPredicate(currentRow: User, searchText: string): boolean {
    const searchTextCheck: boolean = [currentRow.username, currentRow.email, currentRow.fullName, currentRow.organization].some(userField => {
      return userField.toLowerCase().includes(searchText.toLowerCase());
    });

    if (this.checked) {
      return !currentRow.approved && searchTextCheck;
    } else {
      return searchTextCheck;
    }
  }

  updatePendingFilter() {
    // this updates the filterPredicate behind the scenes because Material is sneaky
    this.dataSource.filter = (this.dataSource.filter === '') ? ' ' : this.dataSource.filter;
  }

  public exportToCsv() {
    const headers = this.displayedColumns.join(',');
    const rows = this.dataSource.data.map(user => {
      return [
        FileDownload.formatCsvCell(user.firstName || 'N/A'),
        FileDownload.formatCsvCell(user.lastName || 'N/A'),
        FileDownload.formatCsvCell(user.email || 'N/A'),
        FileDownload.formatCsvCell(user.username || 'N/A'),
        FileDownload.formatCsvCell(user.organization || 'N/A'),
        FileDownload.formatCsvCell(user.joinDate?.format() || 'N/A'),
        FileDownload.formatCsvCell(user.lastLoginDate?.format() || 'N/A'),
      ].join();
    });


    const csvContent = [headers, ...rows];
    FileDownload.downloadCSV('tasti_grid_users', csvContent.join('\n'));

  }
}
